import { getComponentContentById } from "@cappelendamm/crystallize-utils";
import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
import GetSeriesBySubscriptionSku from "../queries/GetSeriesBySubscriptionSku.pim.js";
export const fetchSeriesBySubscriptionSku = async ({ sku }, { client }) => {
    const productVariantQuery = await client.pim.request(GetSeriesBySubscriptionSku, {
        skus: [sku],
        tenantId: client.tenantId,
        language: "no-nb",
    });
    const product = selectProduct(productVariantQuery);
    if (!product) {
        return;
    }
    const seriesDefinition = selectSeriesDefinition(product);
    if (!seriesDefinition) {
        return;
    }
    return {
        name: seriesDefinition.name ?? undefined,
        status: selectSeriesDefinitionStatus(seriesDefinition),
        products: selectBooksInSeries(seriesDefinition),
    };
};
function selectProduct(productQuery) {
    return productQuery?.product?.getVariants?.[0]?.product;
}
function selectSeriesDefinition(product) {
    const seriesDefinitionComponent = getComponentContentById(product.components, CRYSTALLIZE_IDS.SHAPE.PRODUCT.SERIES_SUBSCRIPTION.SERIES_DEFINITION);
    return seriesDefinitionComponent?.items?.[0];
}
function selectSeriesDefinitionStatus(seriesDefinition) {
    const seriesStatusContent = getComponentContentById(seriesDefinition.components, CRYSTALLIZE_IDS.SHAPE.DOCUMENT.SERIES_DEFINITION.SERIES_STATUS);
    return seriesStatusContent?.options?.[0]?.key;
}
function selectBooksInSeries(seriesDefinition) {
    const booksInSeriesComponent = getComponentContentById(seriesDefinition.components, CRYSTALLIZE_IDS.SHAPE.DOCUMENT.SERIES_DEFINITION.SERIES_BOOKS);
    const books = booksInSeriesComponent?.productVariants;
    if (!books) {
        return;
    }
    return books;
}
